import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/http/api.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ModalController } from '@ionic/angular';
import { VARS } from '../../services/constants/constants.service';

@Component({
  selector: 'app-show-notification',
  templateUrl: './show-notification.component.html',
  styleUrls: ['./show-notification.component.scss'],
})
export class ShowNotificationComponent implements OnInit {
  @Input() data: any = 0;
  constructor(private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private modalCtrl: ModalController
    ) { }

  ngOnInit() {
    // console.log('content', this.data, this.data.notification);
  }

  close() {
    this.modalCtrl.dismiss();
  }

  readNotification() {
    if(this.data && !this.data?.read_status) {
    let sendDAta = {
      program_id: VARS.PROGRAM_ID,
      notification_id: this.data.id
    }
    this.apiService.post(this.apiConfig.readNotification, sendDAta)
      .subscribe((res: any) => {
        console.log('success');
        if (res.status == 200) {
          this.modalCtrl.dismiss();
        }
      }, err => {

      })
    } else {
      this.modalCtrl.dismiss();
    }
  }

}
